import React from "react";
import { EuiTitle } from "@elastic/eui";
import { COLORS } from "Consts";
import { createUseStyles } from "react-jss";
import { IFDTitleProps } from "./FDTitle";

const useFDFlyoutTitleStyles = createUseStyles({
  border: {
    borderBottom: `1px solid ${COLORS.$blue}`,
    padding: "5px",
  },
});

export const FDFlyoutTitle = React.memo<IFDTitleProps>(
  ({ titleSize = "xs", title, hasBorder = false }) => {
    const classes = useFDFlyoutTitleStyles();
    if (!title) return null;
    const size = typeof title === "string" && title.length > 42 ? "xxxs" : titleSize;
    return (
      <EuiTitle className={`flyout-title ${hasBorder ? classes.border : ""}`} size={size}>
        <h4 style={{ color: "#fff" }}>{title}</h4>
      </EuiTitle>
    );
  }
);
